/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Transfer_Payer_Rib_InvalidInputs */

const fr_api_transfer_payer_rib_invalid = /** @type {(inputs: Api_Transfer_Payer_Rib_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le compte donneur d’ordre doit avoir un RIB tunisien de 20 chiffres. Corrigez-le dans les paramètres.`)
};

const en_api_transfer_payer_rib_invalid = /** @type {(inputs: Api_Transfer_Payer_Rib_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The payer account needs a 20-digit Tunisian RIB. Update it in settings.`)
};

/**
* | output |
* | --- |
* | "The payer account needs a 20-digit Tunisian RIB. Update it in settings." |
*
* @param {Api_Transfer_Payer_Rib_InvalidInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_transfer_payer_rib_invalid = /** @type {((inputs?: Api_Transfer_Payer_Rib_InvalidInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Transfer_Payer_Rib_InvalidInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_transfer_payer_rib_invalid(inputs)
	return fr_api_transfer_payer_rib_invalid(inputs)
});